"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const ThemeUtils = {
  shadeColor: (color, percent) => {
    if (color.indexOf("rgb(") !== -1) return ThemeUtils.shadeRGBColor(color, percent);else if (color.indexOf("#") !== -1) return ThemeUtils.shadeHexColor(color, percent);else {
      console.log("Invalid CSS color format (" + color + "). Please use RGB or HEX format.");
      return "#ffffff";
    }
  },
  shadeHexColor: (color, percent) => {
    if (color.length === 4) {
      let r = color.slice(1, 2);
      let g = color.slice(2, 3);
      let b = color.slice(3, 4);
      color = "#" + r + r + g + g + b + b;
    }
    let f = parseInt(color.slice(1), 16);
    let t = percent < 0 ? 0 : 255;
    let p = percent < 0 ? percent * -1 : percent;
    let R = f >> 16;
    let G = f >> 8 & 0x00ff;
    let B = f & 0x0000ff;
    return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
  },
  shadeRGBColor: (color, percent) => {
    let f = color.split(",");
    let t = percent < 0 ? 0 : 255;
    let p = percent < 0 ? percent * -1 : percent;
    let R = parseInt(f[0].slice(4), 10);
    let G = parseInt(f[1], 10);
    let B = parseInt(f[2], 10);
    return "rgb(" + (Math.round((t - R) * p) + R) + "," + (Math.round((t - G) * p) + G) + "," + (Math.round((t - B) * p) + B) + ")";
  },
  shadeBlackColors: (color, percent) => {
    if (color.indexOf("rgb(") !== -1) {
      let f = color.split(",");
      let R = parseInt(f[0].slice(4), 10);
      let G = parseInt(f[1], 10);
      let B = parseInt(f[2], 10);
      return "rgba(" + R + ", " + G + ", " + B + ", ." + percent + ")";
    } else {
      console.log("Invalid CSS color format (" + color + "). Please use RGB format for Black color.");
      return "rgb(255,255,255)";
    }
  }
};
var _default = exports.default = ThemeUtils;